<template>
	<div style="width: 100vw;" :style="{minHeight:'calc(100vh - ' + placeNavHeight + 'px)' }">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div style="background-color: #fff;margin: auto;" :style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
				minHeight:'calc(100vh - ' + placeNavHeight + 'px)' 
		 	}:{
		 		width:'100%',
				minHeight:'calc(100vh - ' + placeNavHeight + 'px)' 
		 	}">
			<div style="height: 30px;width: 1px;"></div>

			<!-- <div style="display: flex;justify-content: center;width: 100%;"
				v-if="data && categoriesData.products.data.length == 0">
				<el-empty style="margin: auto;margin-top: 40px;" :description="$t('h.noData')"></el-empty>
			</div> -->

			<div v-if="data" style="">
				<div :style="getColumns()"
					style="max-width: 100%;display: grid;margin-top: 10px;justify-content: space-around;">
					<single-goods style="max-width: 100%;" v-for="(item,index) in data" :key="index" :goodsData="{
							...item,
							image_format:item.image_format
						}" :equipment="equipment" :selectdItem="selectdItem" type="build"></single-goods>
				</div>
			</div>
			<div style="height: 40px;width:  1px;"></div>
			<div v-if="$route.params.id == 'all' && data &&  data.length > 0"
				style="margin-top: 20px;width: 100%;display: flex;justify-content: center;">
				<div
				 :style="{
				 	flexDirection:equipment == 'pc'?'row':'column'
				 }"
				 style="display: flex;align-items: center;">
					<el-pagination @current-change="currentChange" :page-size="15" layout="prev, pager, next" :total="total"
						:style="{
						'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
						'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
					}">
					</el-pagination>
					<div :style="{
						color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
					}" style="font-size: 13px;">{{$t('h.allNum')}} {{total}} </div>
				</div>
			</div>

			<div style="height: 30px;width:  1px;"></div>
		</div>
	</div>
</template>

<script>
	import {
		getSearchCategory,
		getAccountCollect,
		getProductsSearchData,
		getTypeProducts
	} from '../../../api/all.js'
	import singleGoods from '../../components/singleGoods.vue'

	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import lodash from 'lodash';
	export default {
		components: {
			singleGoods
		},
		props: {
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},

		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig', 'classifyListPreview']),
		},
		data() {
			return {
				selectdItem: {
					compontChildren: [{
						layoutConfig: {
							classFiyConfig: {
								paginationHoverColor: "#55aaff",
								paginationSelectColor: "#55aaff"
							},
							goodsConfig: {}
						}
					}]
				},
				value: "",
				list: [],
				searchValue: "",
				iframeLogin: false,
				dialogVisible: false,
				selectItem: null,
				search: {
					type: 'hot'
				},
				page: 1,
				total: 0,
				loading: false,
				data: null
			}
		},

		watch: {
			$route: {
				deep: true,
				handler: async function(to, from) {
					this.page = 1
					this.data = []
					this.getData()

				}
			}
		},

		mounted() {
			if (this.goodsConfig.length > 0) {
				console.log('classifyListPreview', this.classifyListPreview)
				if (this.classifyListPreview.length > 0) {

					this.classifyListPreview.forEach(item => {
						if (item.name == '商品分类') {
							this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = lodash.cloneDeep(
								item.children[0].children[0].compontChildren[0].layoutConfig.classFiyConfig
							)
						}
					})

					// this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = this.classifyListPreview[0].compontChildren[0].layoutConfig.classFiyConfig
				}
				this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				this.$forceUpdate()
			}
			this.getData()

		},
		methods: {
			getColumns() {
				let goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				let num = 1
				if (this.equipment == 'pc') {
					num = goodsConfig.pcNum
				} else {
					num = goodsConfig.phoneNum
				}
				
				let gridRowGap;
				let gridColumnGap;
				if(this.equipment == 'pc'){
					gridRowGap = goodsConfig.rowGap + 'px'
					gridColumnGap = goodsConfig.columnGap + 'px'
				}else{
					gridRowGap = goodsConfig.phoneRowGap + 'px'
					gridColumnGap = goodsConfig.phoneColumnGap + 'px'
				}
				
				console.log('getColumnsgridRowGap',gridRowGap)
				console.log('gridColumnGap',gridColumnGap)
				return {
					gridRowGap: gridRowGap,
					gridColumnGap: gridColumnGap,
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?goodsConfig.columnGap: goodsConfig.phoneColumnGap}px))`
				}
			},
			navTo(item) {
				this.$router.push({
					path: '/products/' + item.url_name,

				})
			},
			getLayStyle() {
				if (this.equipment == 'pc') {
					return 'display: grid;cursor: pointer;grid-template-columns: repeat(auto-fill, 300px); grid-gap: 40px 40px;justify-content: center;'
				} else {
					return {
						display: 'flex',
						flexWrap: 'wrap'
					}
				}
			},
			currentChange(e) {
				this.page = e
				this.getData()
			},
			async getData() {
				try {
					// let type = 'hot'
					// if (this.$route.params.id == 'typeNew') {

					// 	type = 'new'
					// }
					// if (this.$route.params.id == 'typevisit') {
					// 	type = 'visit'
					// }
					// if (this.$route.params.id == 'typeAll') {
					// 	type = 'all'
					// }

					let type = this.$route.params.id
					// if (this.$route.params.id == 'typeNew') {

					// 	type = 'new'
					// }
					// if (this.$route.params.id == 'typevisit') {
					// 	type = 'visit'
					// }
					// if (this.$route.params.id == 'typeAll') {
					// 	type = 'all'
					// }


					this.loading = true
					const data = await getTypeProducts({
						type,
						page: type == 'all' ? this.page : undefined
					})
					console.log('data', data)
					if (type == 'all') {
						this.data = data.data.data.data
						this.total = data.data.data.total
					} else {
						this.data = data.data.data
					}

					this.loading = false
				} catch (e) {
					this.loading = false
				}
				// await
			}
		}
	}
</script>

<style scoped lang="scss">
	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
	}

	::v-deep .el-input__inner:focus {
		border: solid 1px #000000;
	}

	::v-deep .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #000000;
	}

	::v-deep .el-select .el-input__inner:focus {
		border: 1px solid #000000;
	}

	::v-deep .el-pager {

		.active {
			color: var(--selectColor);
		}

		li:hover {
			color: var(--hoverColor);
		}

		li {
			background-color: rgb(0 0 0 / 0%);
		}
	}

	::v-deep .el-pagination {
		.btn-prev {
			background-color: rgb(0 0 0 / 0%);
		}

		.btn-next {
			background-color: rgb(0 0 0 / 0%);
		}

		button:hover {
			color: var(--hoverColor);
		}
	}
</style>